import { render, staticRenderFns } from "./ApprovalTaskPage.vue?vue&type=template&id=bbc30056"
import script from "./ApprovalTaskPage.vue?vue&type=script&lang=js"
export * from "./ApprovalTaskPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports